<template>
  <div>
    <b-row v-if="!isCurrentPersonFinalReportData" class="m-0 py-2">
      <b-col>
        <b-overlay :show="loading" opacity="1" class="text-center py-2">
          <template #overlay>
            <b-spinner small></b-spinner>
            <strong class="ml-2" v-text="$lang.getInfoLoadingText" />
          </template>
          <b-alert
            class="text-center"
            show
            variant="info"
            v-html="errorMessage"
          />
        </b-overlay>
      </b-col>
    </b-row>
    <b-row v-if="isCurrentPersonFinalReportData" class="m-0 bg-white">
      <b-col>
        <b-overlay :show="loading">
          <b-row>
            <b-col
              v-if="personFinalReportData.length > 1"
              cols="12"
              md="12"
              class="text-center pb-3 border_bottom_dashed"
            >
              <div class="text-left">
                <strong v-text="'سایر پرونده‌های شما: '" />
                <b-row class="mt-3">
                  <b-col
                    cols="12"
                    md="auto"
                    v-for="(item, index) in personFinalReportDataFilter"
                    :key="index"
                  >
                    <b-button
                      variant="outline-dark"
                      v-text="pathOr('', ['parvandeh', 'caption'], item)"
                      @click="setCurrentItem(item)"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-overlay>
      </b-col>
    </b-row>
    <b-row v-if="isCurrentPersonFinalReportData" class="m-0 bg-white">
      <b-col>
        <export-pdf @onProgress="onProgress" :generatePdf="generatePdf">
          <template slot="content">
            <b-overlay :show="loading" class="section">
              <b-row class="m-0">
                <b-col class="position-relative p-0">
                  <div v-if="watermark" class="watermark" v-text="watermark" />
                </b-col>
              </b-row>
              <b-row class="m-0 py-3 text-center">
                <b-col cols="12" md="auto" class="d-none d-md-block">
                  <b-img :src="logoImgBase64" fluid width="150" />
                </b-col>
                <b-col cols="12" md="" class="text-center my-3">
                  <h4
                    class="font-weight-bold lh_30"
                    v-text="$lang.project_description"
                  />
                  <h5
                    class="font-weight-bold lh_30"
                    v-text="$lang.reportCardSecondTitle"
                  />
                  <h5 class="font-weight-bold" v-text="termCaption" />
                </b-col>
                <b-col cols="12" md="auto">
                  <b-img
                    :src="personImageBase64"
                    thumbnail
                    fluid
                    width="150"
                    class="bg-white"
                  />
                </b-col>
              </b-row>
              <b-row class="m-0 d-none">
                <b-col cols="12" md="6">
                  <div
                    v-text="$lang.doInterviewDate.replace('{0}', interviewDate)"
                    class="
                      bg-info
                      text-center
                      py-2
                      w-100
                      fs_16
                      font-weight-bold
                      rounded
                      mb-3
                      lh_45
                    "
                  />
                </b-col>
                <b-col cols="12" md="6">
                  <div
                    v-text="`${$lang.internalCode}: ${internalCode}`"
                    class="
                      bg-info
                      text-center
                      py-2
                      w-100
                      fs_16
                      font-weight-bold
                      rounded
                      mb-3
                    "
                  />
                </b-col>
              </b-row>
              <b-row class="m-0">
                <b-col cols="12" md="6">
                  <tableVariant
                    :title="$lang.person_info"
                    headerClass="bg-secondary text-dark"
                    :items="userInfoItems"
                  />
                </b-col>
                <b-col cols="12" md="6" v-if="interviewItems.length">
                  <tableVariant
                    :title="$lang.reportCardInterviewResult"
                    headerClass="bg-secondary text-dark"
                    :items="interviewItems"
                  />
                </b-col>
                <b-col cols="12" md="6" v-if="enteringAzmoonItems.length">
                  <tableVariant
                    :title="$lang.reportCardTestExecute"
                    headerClass="bg-secondary text-dark"
                    :items="enteringAzmoonItems"
                  />
                </b-col>
                <b-col cols="12" md="6">
                  <tableVariant
                    :title="$lang.reportCardLastRate"
                    headerClass="bg-secondary text-dark"
                    footerClass="font-weight-bold text-dark bg-info"
                    :hasFooter="true"
                    :items="lastRateItems"
                  >
                    <template slot="footer">
                      <b-row class="m-0 fs_12" align-v="center">
                        <b-col
                          cols="auto"
                          md="auto"
                          class="text-left p-1"
                          v-text="`${$lang.reportCardLastRateFooter} :`"
                        />
                        <b-col
                          cols=""
                          md=""
                          class="text-right p-1"
                          v-text="finalResultCaption"
                        />
                      </b-row>
                    </template>
                  </tableVariant>
                </b-col>
                <b-col
                  cols="12"
                  md="12"
                  class="border-top"
                  v-html="interviewResultState"
                />
              </b-row>
            </b-overlay>
          </template>
        </export-pdf>
      </b-col>
    </b-row>
    <b-row v-if="isCurrentPersonFinalReportData" class="m-0 bg-white">
      <b-col>
        <b-overlay :show="loading">
          <b-row>
            <b-col cols="12" md="12" class="text-center py-3 border_top_dashed">
              <b-overlay
                :show="buttonLoading > 0"
                spinner-small
                class="d-inline-block"
              >
                <b-button class="m-1" variant="primary" @click="print">
                  <i class="fas fa-download mr-2" />
                  <strong v-text="$lang.getPdfVersion" />
                </b-button>
              </b-overlay>
              <b-button
                v-b-tooltip.hover
                :title="$lang.setProtestTooltip"
                class="m-1"
                variant="outline-danger"
                @click="setProtest()"
              >
                <i class="fas fa-edit mr-2" />
                <strong v-text="$lang.setProtest" />
              </b-button>
            </b-col>
          </b-row>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import tableVariant from "./components/tableVariant.vue";
import exportPdf from "@/components/base/exportPdf";
import { pathOr } from "ramda";
import { convertUrlToBase64, checkActiveParvandeh } from "@/shared/utils";

export default {
  components: {
    tableVariant,
    "export-pdf": exportPdf,
  },
  data() {
    return {
      loading: false,
      buttonLoading: 0,
      generatePdf: false,
      logoImgUrl: this.$config.images.tinyLogo,
      logoImgBase64: null,
      errorMessage: "",
      personFinalReportData: [],
      currentPersonFinalReportData: {},
      activeParvandehData: {},
    };
  },
  computed: {
    userInfoItems() {
      return [
        {
          score0: "شماره پرونده",
          score1: pathOr(
            "",
            ["parvandeh", "parvandeh_number"],
            this.currentPersonFinalReportData
          ),
        },
        {
          score0: "کد‌ملی",
          score1: pathOr(
            "",
            ["person", "national_code"],
            this.currentPersonFinalReportData
          ),
        },
        {
          score0: "نام",
          score1: pathOr(
            "",
            ["person", "name"],
            this.currentPersonFinalReportData
          ),
        },
        {
          score0: "نام خانوادگی",
          score1: pathOr(
            "",
            ["person", "family"],
            this.currentPersonFinalReportData
          ),
        },
        {
          score0: "نام پدر",
          score1: pathOr(
            "",
            ["person", "father_name"],
            this.currentPersonFinalReportData
          ),
        },
      ];
    },
    interviewItems() {
      const interviewResult = pathOr(
        [],
        ["interview", "interview_result"],
        this.currentPersonFinalReportData
      );
      return interviewResult.map((item) => {
        const score = pathOr(null, ["score"], item);
        return {
          score0: pathOr("", ["interview_type", "caption"], item),
          score1: score ? score + "%" : "سفید",
        };
      });
    },
    enteringAzmoonItems() {
      const enteringAzmoonResult = pathOr(
        [],
        ["entering_azmoon"],
        this.currentPersonFinalReportData
      );
      return enteringAzmoonResult.map((item) => {
        const score = pathOr(null, ["score"], item);
        return {
          score0: pathOr("", ["azmoon_item", "caption"], item),
          score1: score ? score + "%" : "سفید",
        };
      });
    },
    lastRateItems() {
      const text = "در هیچ یک از حوزه‌های انتخابی قبول نشده اید";
      const hozehGhazayiDetail = pathOr(
        null,
        ["final_rank", "hozeh_ghazayi", "detail"],
        this.currentPersonFinalReportData
      );
      const hozeGhazayiDetailText = hozehGhazayiDetail ? text : "-";
      const items = {
        کارشناسی: [
          {
            score0: "نوع سهمیه",
            score1: pathOr(
              "-",
              ["final_rank", "quota_type"],
              this.currentPersonFinalReportData
            ),
          },
          {
            score0: "حوزه استانی محل قبولی در آزمون کتبی",
            score1: pathOr(
              "-",
              ["final_rank", "hozeh_ghazayi", "province", "caption"],
              this.currentPersonFinalReportData
            ),
          },
          {
            score0: "حوزه قبولی در آزمون کتبی",
            score1: pathOr(
              "-",
              ["final_rank", "hozeh_ghazayi", "detail", "caption"],
              this.currentPersonFinalReportData
            ),
          },
          {
            score0: "رتبه در سهمیه استان محل قبولی",
            score1: pathOr(
              "-",
              ["final_rank", "rank_in_province"],
              this.currentPersonFinalReportData
            ),
          },
          {
            score0: "رتبه در سهمیه رشته استان محل قبولی",
            score1: pathOr(
              "-",
              ["final_rank", "rank_grade_in_province"],
              this.currentPersonFinalReportData
            ),
          },
          {
            score0: "نمره تراز",
            score1: pathOr(
              "-",
              ["final_rank", "level_score"],
              this.currentPersonFinalReportData
            ),
          },
          {
            score0: "حد نصاب قبولی",
            score1: pathOr(
              "-",
              ["final_rank", "minimum_accept_score"],
              this.currentPersonFinalReportData
            ),
          },
          /* {
            score0: "نمره آخرین نفر قبولی",
            score1: pathOr(
              "-",
              ["final_rank", "last_accept_score"],
              this.currentPersonFinalReportData
            ),
          }, */
        ],
        وکالت: [
          {
            score0: "نوع سهمیه",
            score1: pathOr(
              "-",
              ["final_rank", "quota_type"],
              this.currentPersonFinalReportData
            ),
          },
          {
            score0: "استان محل قبولی در آزمون کتبی",
            score1: pathOr(
              "-",
              ["final_rank", "hozeh_ghazayi", "province", "caption"],
              this.currentPersonFinalReportData
            ),
          },
          {
            score0: "حوزه قضایی نهایی",
            score1: pathOr(
              hozeGhazayiDetailText,
              ["final_rank", "hozeh_ghazayi", "detail", "caption"],
              this.currentPersonFinalReportData
            ),
          },
          {
            score0: "نمره کل آزمون کتبی",
            score1: pathOr(
              "-",
              ["final_rank", "entering_azmoon_final_score"],
              this.currentPersonFinalReportData
            ),
          },
          {
            score0: "نمره کل آزمون شفاهی",
            score1: pathOr(
              "-",
              ["final_rank", "final_interview_score"],
              this.currentPersonFinalReportData
            ),
          },
          {
            score0: "نمره تراز نهایی	",
            score1: pathOr(
              "-",
              ["final_rank", "final_average_score"],
              this.currentPersonFinalReportData
            ),
          },
          // {
          //   score0: pathOr(
          //     "-",
          //     ["final_rank", "last_person_score", "caption"],
          //     this.currentPersonFinalReportData
          //   ),
          //   score1: pathOr(
          //     "-",
          //     ["final_rank", "last_person_score", "score"],
          //     this.currentPersonFinalReportData
          //   ),
          // },
          {
            score0: "رتبه در استان و سهمیه انتخابی",
            score1: pathOr(
              "-",
              ["final_rank", "level_in_province"],
              this.currentPersonFinalReportData
            ),
          },
          {
            score0: "آخرین رتبه قبولی در استان و سهمیه انتخابی",
            score1: pathOr(
              "-",
              ["final_rank", "last_rank_in_province"],
              this.currentPersonFinalReportData
            ),
          },
        ],
      };
      return items[this.licenseCaption];
    },
    finalResultId() {
      return pathOr(
        null,
        ["final_rank", "final_result", "id"],
        this.currentPersonFinalReportData
      );
    },
    finalResultCaption() {
      return pathOr(
        "",
        ["final_rank", "final_result", "caption"],
        this.currentPersonFinalReportData
      );
    },

    interviewDate() {
      return pathOr(
        "",
        ["interview", "interview_time", "jalali"],
        this.currentPersonFinalReportData
      );
    },
    personImageBase64() {
      const base64Src = pathOr(
        "",
        ["person", "attachment", "base_64"],
        this.currentPersonFinalReportData
      );
      const mimeType = pathOr(
        "",
        ["person", "attachment", "mime_type"],
        this.currentPersonFinalReportData
      );
      return `data:${mimeType};base64,${base64Src}`;
    },
    internalCode() {
      return pathOr(
        "",
        ["person", "internal_code"],
        this.currentPersonFinalReportData
      );
    },
    personFinalReportDataFilter() {
      return this.personFinalReportData.filter(
        (item) =>
          pathOr(null, ["parvandeh", "code"], item) !==
          pathOr(null, ["parvandeh", "code"], this.currentPersonFinalReportData)
      );
    },
    licenseCaption() {
      return pathOr(
        "",
        ["license", "caption"],
        this.currentPersonFinalReportData
      );
    },
    termCaption() {
      return pathOr("", ["term", "caption"], this.currentPersonFinalReportData);
    },
    isCurrentPersonFinalReportData() {
      return !!Object.keys(this.currentPersonFinalReportData).length;
    },
    interviewResultState() {
      return pathOr(
        "",
        ["interview", "interview_result_state"],
        this.currentPersonFinalReportData
      );
    },
    watermark() {
      return pathOr(
        null,
        ["watermark_message"],
        this.currentPersonFinalReportData
      );
    },
    parvandehCode() {
      return pathOr(null, ["code"], this.activeParvandehData);
    },
  },
  watch: {
    $route() {
      this.getPersonFinalReport();
    },
  },
  created() {
    this.logoBase64Generate();
    this.getPersonFinalReport();
  },
  methods: {
    pathOr,
    checkActiveParvandeh,
    print() {
      window.print();
      // window.close();
    },
    onProgress() {
      this.buttonLoading = this.buttonLoading == 1 ? 2 : 0;
      this.generatePdf = false;
    },
    generateReport() {
      this.buttonLoading = 1;
      this.generatePdf = true;
    },
    async getPersonFinalReport() {
      this.activeParvandehData = { ...checkActiveParvandeh(false) };
      try {
        this.loading = true;

        let url =
          this.$config.api_url +
          this.$config.interview.interview_final_result.replace(
            "{0}",
            this.parvandehCode
          );

        if (this.$route.name === "interview_final_result") {
          const code = pathOr(null, ["code"], this.$route.params);
          if (!code) {
            this.$notify.error("درخواست شما نامعتبر می‌باشد");
            return;
          }
          url =
            this.$config.api_url +
            this.$config.interview.parvandeh_interview_final_result.replace(
              "{0}",
              code
            );
        }

        const response = await this.$httpService.get(url);
        this.personFinalReportData = {
          ...pathOr({}, ["data", "data"], response),
        };
        this.currentPersonFinalReportData = this.personFinalReportData
          ? { ...this.personFinalReportData }
          : null;
      } catch (error) {
        this.errorMessage = pathOr("", ["response", "data", "message"], error);
      } finally {
        this.loading = false;
      }
    },
    logoBase64Generate() {
      convertUrlToBase64(this.logoImgUrl, (data) => {
        this.logoImgBase64 = data;
      });
    },
    setProtest() {
      const protestRouteData = this.$router.resolve({
        name: "add_protest_ticket",
      });
      window.open(protestRouteData.href, "_blank");
    },
    setCurrentItem(item) {
      this.currentPersonFinalReportData = { ...item };
      const message = `اطلاعات پرونده ${pathOr(
        "",
        ["parvandeh", "caption"],
        item
      )} با موفقیت دریافت شد`;
      this.$notify.success(message);
    },
  },
};
</script>
<style lang="scss" scoped>
ul {
  list-style: none;
}
.border_bottom_dashed {
  border-bottom: 1px dashed #c8ced3;
}
.border_top_dashed {
  border-top: 1px dashed #c8ced3;
}
.section {
  display: block;
  padding: 1px;
}
$rotate_deg: -27deg;
.watermark {
  position: absolute;
  width: 100%;
  top: 400px;
  font-size: 2rem;
  font-weight: 900;
  text-align: center;
  color: #831b1bb8;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate($rotate_deg);
  -webkit-transform: rotate($rotate_deg);
  -moz-transform: rotate($rotate_deg);
}
</style>
